export const environment = {
  production: false,
  apiUrl: 'https://qa-sa-api.equinemedirecord.com/api/v1',
  socketUrl: 'https://qa-sa-api.equinemedirecord.com',
  socketPort: ':6001',
  maxImgCount: 5,
  maxImgSize: '157286400', // in bytes
  defaultLanguage: 'en',
  languages: ['sa', 'en'],
  country: 'sa',
  availableCountries: {
    ireland: 'https://qa-ie-app.equinemedirecord.com',
    uk: 'https://qa-uk-app.equinemedirecord.com',
    france: 'https://qa-fr-app.equinemedirecord.com',
    usa: 'https://qa-us-app.equinemedirecord.com',
    saudi: 'https://qa-sa-app.equinemedirecord.com',
  },
  stripeKey: 'pk_test_37ClOdBt2dkVZ4Vp7wESYQZI00rxaDoF3n',
  quick_treatment: false,
  currency: 'USD',
  showRegionsSelect: true,         //only for USA or SA
  ruleBookPdf: '/assets/rulebook_usa_ky.pdf',
  ruleBookKYPdf: '/assets/rulebook_usa_ky.pdf',
  ruleBookCAPdf: '/assets/rulebook_usa_ca.pdf',
  ruleBookBCPdf: '/assets/rulebook_usa_bc.pdf',
  ruleBookSCPdf: '/assets/rulebook_sa_sc.pdf',
  ruleBookBCPdPopup: '/assets/rulebook_sa_sc_popup.pdf',
  ruleBookSC24Pdf: '/assets/rulebook_sa_sc24.pdf',
  filterRegionForDrugs: true,
  showModalUnvaccinated: false,
  showInTheFoodChainToggle: false,
  dateFormat: 'dd/MM/yyyy',     // 'MM/dd/yyyy'
  disableTreatmentEditInstructorNotOwned: true,    //If set to true instructor (trainer) can not edit treatments not created by him.
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts